import { firebaseApp } from './Firebase'
import 'firebase/compat/auth'

export let firebaseUserID: string = ''

firebaseApp.auth().onAuthStateChanged((user) => {
  if (user) {
    firebaseUserID = user.uid
  } else {
    firebaseUserID = ''
    firebaseApp.auth().signInAnonymously()
  }
})

firebaseApp.auth().signInAnonymously()
